// removed by extract-text-webpack-plugin
module.exports = {"button":"BaseButton_button_33Hj8"};